import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect, { SimpleSelectProps } from 'carbon-react/lib/components/select/simple-select';

import { ForecastFormElementIds } from '../../types';

export interface ForecastSourceForecastProps extends Omit<SimpleSelectProps, 'name' | 'id' | 'children' | 'label'> {
  forecasts?: { id: string; name: string }[];
  type: 'budget' | 'forecast';
}

export const ForecastSourceForecast = ({ forecasts, type, ...props }: ForecastSourceForecastProps) => {
  const intl = useIntl();

  const label = useMemo(() => {
    if (type === 'budget') {
      return intl.formatMessage({
        id: 'predict.create_forecast.select_budget_to_copy_predictions_from_v2',
        defaultMessage: 'Select budget or forecast to copy predictions from'
      });
    } else {
      return intl.formatMessage({
        id: 'predict.create_forecast.select_budget_to_copy_predictions_from_v2',
        defaultMessage: 'Select budget or forecast to copy predictions from'
      });
    }
  }, [intl, type]);

  return (
    <SimpleSelect
      name={ForecastFormElementIds.SourceForecast}
      id={ForecastFormElementIds.SourceForecast}
      label={label}
      required
      {...props}
    >
      {forecasts?.map(forecast => (
        <Option key={forecast.id} text={forecast.name} value={forecast.id} />
      ))}
    </SimpleSelect>
  );
};
